var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b(
      {
        staticClass: "render-sort",
        on: {
          click: function($event) {
            return _vm.sort()
          }
        }
      },
      "div",
      _vm.$attrs,
      false
    ),
    [
      _vm.currentColumnFiltered !== _vm.columnKey
        ? _c("b-icon", {
            attrs: { icon: "arrow-up-short", scale: "1.5", variant: "dark" }
          })
        : _vm.currentColumnFiltered === _vm.columnKey &&
          _vm.sortDirection === "ASC"
        ? _c("b-icon", {
            attrs: { icon: "arrow-up-short", scale: "1.5", variant: "success" }
          })
        : _c("b-icon", {
            attrs: {
              icon: "arrow-down-short",
              scale: "1.5",
              variant: "success"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }